import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';
import { ResolucionIndexComponent } from './ResolucionIndex.component';
import { ResolucionEditComponent } from './ResolucionEdit.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [

{
    path      : 'Resolucion',
    component: ResolucionIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Resolucion',
          nombreFormulario : 'Consultar Resolucion'
        } 
},{
    path 	 : 'Resolucion/:cnumcont/:cprefijo',
    component: ResolucionIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Resolucion',
          nombreFormulario : 'Consultar Resolucion'
        } 
},{
    path      : 'Resolucion/e/:cnumcont/:cprefijo',
    component: ResolucionEditComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Resolucion',
          nombreFormulario : 'Editar Resolucion'
        } 
}
];

@NgModule({
    declarations: [
        ResolucionIndexComponent,
        ResolucionEditComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports  : [
        ResolucionIndexComponent,
        ResolucionEditComponent
    ]
})


export class ResolucionModule

{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Resoluciones/Resolucion.module.ts